/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
import type { SavedStateTypeEnum } from "./SavedStateTypeEnum";
import {
  SavedStateTypeEnumFromJSON,
  SavedStateTypeEnumFromJSONTyped,
  SavedStateTypeEnumToJSON,
  SavedStateTypeEnumToJSONTyped,
} from "./SavedStateTypeEnum";
import type { SavedStateVariableEnum } from "./SavedStateVariableEnum";
import {
  SavedStateVariableEnumFromJSON,
  SavedStateVariableEnumFromJSONTyped,
  SavedStateVariableEnumToJSON,
  SavedStateVariableEnumToJSONTyped,
} from "./SavedStateVariableEnum";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface ThreediModelSavedState
 */
export interface ThreediModelSavedState {
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  name: string;
  /**
   *
   */
  created?: Date | null;
  /**
   *
   */
  type: SavedStateTypeEnum;
  /**
   * tags provided as a list of strings
   */
  tags?: Array<string>;
  /**
   *
   */
  readonly usedInSimulation?: string;
  /**
   *
   */
  expiry?: Date | null;
  /**
   * Time in simulation to create savedstate
   */
  time?: number | null;
  /**
   *
   */
  variables?: Array<SavedStateVariableEnum> | null;
  /**
   *
   */
  thresholds?: Array<number> | null;
}

/**
 * Check if a given object implements the ThreediModelSavedState interface.
 */
export function instanceOfThreediModelSavedState(value: object): value is ThreediModelSavedState {
  if (!("name" in value) || value["name"] === undefined) return false;
  if (!("type" in value) || value["type"] === undefined) return false;
  return true;
}

export function ThreediModelSavedStateFromJSON(json: any): ThreediModelSavedState {
  return ThreediModelSavedStateFromJSONTyped(json, false);
}

export function ThreediModelSavedStateFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ThreediModelSavedState {
  if (json == null) {
    return json;
  }
  return {
    id: json["id"] == null ? undefined : json["id"],
    url: json["url"] == null ? undefined : json["url"],
    name: json["name"],
    created:
      json["created"] === undefined
        ? undefined
        : json["created"] === null
        ? null
        : parseDateTime(json["created"]),
    type: SavedStateTypeEnumFromJSON(json["type"]),
    tags: json["tags"] == null ? undefined : json["tags"],
    usedInSimulation: json["used_in_simulation"] == null ? undefined : json["used_in_simulation"],
    expiry:
      json["expiry"] === undefined
        ? undefined
        : json["expiry"] === null
        ? null
        : parseDateTime(json["expiry"]),
    time: json["time"] === undefined ? undefined : json["time"] === null ? null : json["time"],
    variables:
      json["variables"] === undefined
        ? undefined
        : json["variables"] === null
        ? null
        : (json["variables"] as Array<any>).map(SavedStateVariableEnumFromJSON),
    thresholds:
      json["thresholds"] === undefined
        ? undefined
        : json["thresholds"] === null
        ? null
        : json["thresholds"],
  };
}

export function ThreediModelSavedStateToJSON(json: any): ThreediModelSavedState {
  return ThreediModelSavedStateToJSONTyped(json, false);
}

export function ThreediModelSavedStateToJSONTyped(
  value?: Omit<ThreediModelSavedState, "id" | "url" | "usedInSimulation"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    created: value["created"] == null ? value["created"] : serializeDateTime(value["created"]),
    type: SavedStateTypeEnumToJSON(value["type"]),
    tags: value["tags"],
    expiry: value["expiry"] == null ? value["expiry"] : serializeDateTime(value["expiry"]),
    time: value["time"],
    variables:
      value["variables"] == null
        ? undefined
        : (value["variables"] as Array<any>).map(SavedStateVariableEnumToJSON),
    thresholds: value["thresholds"],
  };
}
